// extracted by mini-css-extract-plugin
export default {"side":"Sidebar_side__KCOhH","logo":"Sidebar_logo__Mc4Gd","menu":"Sidebar_menu__dxY8w","actions":"Sidebar_actions__jpcYm"};